/* RV Custom — minimale theme JS (skeleton). Mobile-first interacties. */
(function () {
  document.documentElement.classList.remove('no-js');

  // ===== Winkelwagen-lade (cart drawer) =====
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  // Urgentie-timer verwijderd (backlog item 2, besluit B4: drawer gestript naar azel).

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function applyCartSection(html) {
    if (!html || !cartDrawer) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-contents]');
    var live = cartDrawer.querySelector('[data-cart-drawer-contents]');
    if (fresh && live) {
      live.innerHTML = fresh.innerHTML;
      var c = fresh.getAttribute('data-count');
      if (c != null) document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c; el.hidden = (parseInt(c, 10) || 0) === 0; });
      // Geslaagde mutatie: eventuele oude foutmelding direct wissen
      var errEl = cartDrawer.querySelector('[data-cart-error]');
      if (errEl) { clearTimeout(errEl._t); errEl.hidden = true; }
    }
  }
  // Foutmelding in de drawer (bv. voorraadlimiet 422) — opent de drawer zodat hij zichtbaar is.
  function showCartError(msg) {
    var el = cartDrawer && cartDrawer.querySelector('[data-cart-error]');
    if (!el) return;
    el.textContent = msg || 'Une erreur s’est produite. Veuillez réessayer.';
    el.hidden = false;
    openCart();
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 6000);
  }
  function cartAdd(id, qty) {
    // Accepteert één variant-id of een array items [{id, quantity}] (bundel-widget).
    var items = Array.isArray(id) ? id : [{ id: id, quantity: qty || 1 }];
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer'], sections_url: window.location.pathname })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) {
          var msg = (err && (err.description || err.message)) || 'add-failed';
          showCartError(msg);
          throw new Error(msg);
        });
      }
      return r.json();
    }).then(function (res) { applyCartSection(res.sections && res.sections['cart-drawer']); return res; });
  }
  function cartChange(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) {
          showCartError((err && (err.description || err.message)) || null);
          throw new Error('change-failed');
        });
      }
      return r.json();
    }).then(function (cart) { applyCartSection(cart.sections && cart.sections['cart-drawer']); return cart; })
      .then(function (cart) { removeOrphanPerso(); return cart; })
      .catch(function (e) { if (e && e.message !== 'change-failed') showCartError(null); throw e; });
  }
  // Personalisatie (12,95) is gekoppeld aan een shirt met Nom/Numéro-properties.
  // Verdwijnt dat shirt uit de winkelwagen, dan mag de optie-regel niet als wees
  // blijven staan (klant zou anders voor niets betalen). Zelf-dovend: na de
  // opruim-change is er geen wees meer, dus geen tweede ronde.
  var PERSO_HANDLE = 'personnalisation-nom-numero';
  function removeOrphanPerso() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        var heeftPerso = false, heeftDrager = false, persoLine = 0;
        cart.items.forEach(function (item, i) {
          if (item.handle === PERSO_HANDLE) { heeftPerso = true; persoLine = i + 1; return; }
          var p = item.properties || {};
          if (p['Nom'] || p['Numéro']) heeftDrager = true;
        });
        if (heeftPerso && !heeftDrager) {
          return cartChange(persoLine, 0).then(function (c) {
            // de cart-PAGINA rendert server-side; na een opruiming éénmalig verversen
            if (location.pathname.indexOf('/cart') === 0) location.reload();
            return c;
          });
        }
        return null;
      })
      .catch(function () {});
  }
  removeOrphanPerso(); // ook bij page load (cart-pagina werkt met gewone links + reload)
  window.RVCart = { open: openCart, close: closeCart, add: cartAdd, change: cartChange };

  function lineQtyFromBtn(btn) {
    var item = btn.closest('[data-cart-item]');
    var v = item && item.querySelector('.qty-selector__val');
    return v ? (parseInt(v.textContent, 10) || 0) : 0;
  }
  if (cartDrawer) {
    document.querySelectorAll('[data-cart-toggle]').forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
    cartDrawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
      // (PSG-upsell wordt afgehandeld door het submit-script in cart-drawer.liquid)
      var up = e.target.closest('[data-qty-up]');
      var down = e.target.closest('[data-qty-down]');
      var rem = e.target.closest('[data-cart-remove]');
      // Fout is al zichtbaar via showCartError; lege catch voorkomt unhandled rejections
      if (up) { cartChange(parseInt(up.getAttribute('data-qty-up'), 10), lineQtyFromBtn(up) + 1).catch(function () {}); }
      else if (down) { cartChange(parseInt(down.getAttribute('data-qty-down'), 10), Math.max(0, lineQtyFromBtn(down) - 1)).catch(function () {}); }
      else if (rem) { cartChange(parseInt(rem.getAttribute('data-cart-remove'), 10), 0).catch(function () {}); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  }

  // Sale-countdown — telt af tot vandaag 23:59:59 (dagelijkse reset)
  var countdownEls = document.querySelectorAll('[data-countdown]');
  if (countdownEls.length) {
    var pad2 = function (n) { return n < 10 ? '0' + n : '' + n; };
    var tickCountdown = function () {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      var diff = Math.floor((end - now) / 1000);
      if (diff < 0) diff = 0;
      var txt = pad2(Math.floor(diff / 3600)) + ':' + pad2(Math.floor((diff % 3600) / 60)) + ':' + pad2(diff % 60);
      countdownEls.forEach(function (el) { el.textContent = txt; });
    };
    tickCountdown();
    setInterval(tickCountdown, 1000);
  }

  // Aankondigingsbalk — handmatig wisselen tussen punten (geen auto-scroll)
  var announce = document.querySelector('[data-announcement]');
  if (announce) {
    var aSlides = announce.querySelectorAll('[data-announce-slide]');
    if (aSlides.length > 1) {
      var aIdx = 0;
      var aShow = function (i) {
        aIdx = (i + aSlides.length) % aSlides.length;
        aSlides.forEach(function (s, j) { s.classList.toggle('is-active', j === aIdx); });
      };
      var aPrev = announce.querySelector('[data-announce-prev]');
      var aNext = announce.querySelector('[data-announce-next]');
      if (aPrev) aPrev.addEventListener('click', function () { aShow(aIdx - 1); });
      if (aNext) aNext.addEventListener('click', function () { aShow(aIdx + 1); });
    }
  }

  // Hero slideshow — auto-rotatie + dot-navigatie
  var hero = document.querySelector('[data-hero-slideshow]');
  if (hero) {
    var slides = hero.querySelectorAll('[data-hero-slide]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    if (slides.length > 1) {
      var idx = 0;
      var seconds = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
      var timer;
      var go = function (i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
      };
      var restart = function () { if (seconds > 0) { clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, seconds * 1000); } };
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hero-dot'), 10)); restart(); }); });
      restart();
    }
  }

  // Mobiel slide-in menu (drawer + overlay + scroll-lock)
  var burger = document.querySelector('[data-menu-toggle]');
  var drawer = document.querySelector('[data-menu-drawer]');
  var overlay = document.querySelector('[data-menu-overlay]');
  var closeBtn = document.querySelector('[data-menu-close]');
  function openMenu() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  // Paneel-reset van de bottom-sheet zit ín open/close zelf (geen monkeypatch);
  // de timer wordt bij heropenen geannuleerd zodat het paneel niet terugflitst.
  var menuPanelResetT = null;
  function showMenuPanel(id) {
    if (!drawer) return;
    drawer.querySelectorAll('[data-menu-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-menu-panel') === id);
    });
  }
  function closeMenu() {
    if (!drawer) return;
    var wasOpen = drawer.classList.contains('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    if (burger) {
      burger.setAttribute('aria-expanded', 'false');
      if (wasOpen) burger.focus(); // focus terug naar de trigger
    }
    document.body.style.overflow = '';
    if (wasOpen && drawer.querySelector('[data-menu-panels]')) {
      clearTimeout(menuPanelResetT);
      menuPanelResetT = setTimeout(function () { showMenuPanel('root'); }, 300);
    }
  }
  if (burger) burger.addEventListener('click', function () { clearTimeout(menuPanelResetT); openMenu(); });
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

  // Bottom-sheet: schuifpanelen per submenu (azel, backlog item 6)
  var menuPanels = drawer && drawer.querySelector('[data-menu-panels]');
  if (menuPanels) {
    menuPanels.addEventListener('click', function (e) {
      var open = e.target.closest('[data-submenu-open]');
      var back = e.target.closest('[data-submenu-back]');
      if (open) showMenuPanel(open.getAttribute('data-submenu-open'));
      else if (back) showMenuPanel('root');
    });
  }

  // ===== Productgalerij: hoofdcarousel + thumbs + dots + video + lightbox =====
  var gallery = document.querySelector('.product__media-gallery');
  var thumbs = document.querySelectorAll('.product__thumbnail');
  var mediaDots = document.querySelectorAll('.product__media-dot');
  if (gallery) {
    var items = gallery.querySelectorAll('.product__media-item');

    // Actieve slide markeren: thumbs + dots + video's (alleen actieve video speelt)
    var markActive = function (idx) {
      items.forEach(function (it, j) {
        it.classList.toggle('is-active', j === idx);
        var vid = it.querySelector('video');
        if (vid) {
          if (j === idx) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
          else { vid.pause(); }
        }
      });
      thumbs.forEach(function (x, j) { x.classList.toggle('is-active', j === idx); });
      mediaDots.forEach(function (x, j) { x.classList.toggle('is-active', j === idx); });
      var activeThumb = thumbs[idx];
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    };
    var currentIdx = function () { return Math.round(gallery.scrollLeft / gallery.clientWidth); };
    var goToMedia = function (i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      var target = items[i];
      if (target) gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      markActive(i);
    };

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goToMedia(parseInt(t.getAttribute('data-thumb-index'), 10)); });
    });
    mediaDots.forEach(function (d) {
      d.addEventListener('click', function () { goToMedia(parseInt(d.getAttribute('data-media-dot'), 10)); });
    });
    gallery.addEventListener('scroll', function () { window.requestAnimationFrame(function () { markActive(currentIdx()); }); }, { passive: true });

    // Vorige/volgende-pijlen op de hoofdfoto
    var prevBtn = document.querySelector('[data-media-prev]');
    var nextBtn = document.querySelector('[data-media-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goToMedia(currentIdx() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToMedia(currentIdx() + 1); });

    // Pijltjes bij de thumbnail-strip (verticaal naast de foto, horizontaal eronder)
    var thumbsScroller = document.querySelector('[data-thumbs-scroller]');
    var thumbsStep = function (dir) {
      if (!thumbsScroller) return;
      var vertical = thumbsScroller.scrollHeight > thumbsScroller.clientHeight + 4;
      if (vertical) thumbsScroller.scrollBy({ top: dir * thumbsScroller.clientHeight * 0.8, behavior: 'smooth' });
      else thumbsScroller.scrollBy({ left: dir * thumbsScroller.clientWidth * 0.8, behavior: 'smooth' });
    };
    var tPrev = document.querySelector('[data-thumbs-prev]');
    var tNext = document.querySelector('[data-thumbs-next]');
    if (tPrev) tPrev.addEventListener('click', function () { thumbsStep(-1); });
    if (tNext) tNext.addEventListener('click', function () { thumbsStep(1); });

    // Eerste slide: video meteen starten (muted)
    markActive(0);

    // ---- Zoom-lightbox: klik op foto -> fullscreen dialog met swipe/pijlen/zoom ----
    var lightbox = document.querySelector('[data-media-lightbox]');
    if (lightbox && typeof lightbox.showModal === 'function') {
      var lbTrack = lightbox.querySelector('[data-lightbox-track]');
      var lbItems = lightbox.querySelectorAll('[data-lightbox-item]');
      var lbCounter = lightbox.querySelector('[data-lightbox-counter]');
      var lbLoaded = false;
      var lbLoad = function () {
        if (lbLoaded) return;
        lbLoaded = true;
        lightbox.querySelectorAll('img[data-src]').forEach(function (im) {
          im.src = im.getAttribute('data-src');
          im.removeAttribute('data-src');
        });
      };
      var lbIndex = function () { return lbTrack ? Math.round(lbTrack.scrollLeft / lbTrack.clientWidth) : 0; };
      var lbSync = function () {
        if (lbCounter) lbCounter.textContent = (lbIndex() + 1) + ' / ' + lbItems.length;
      };
      var lbGoTo = function (i, instant) {
        i = Math.max(0, Math.min(lbItems.length - 1, i));
        var target = lbItems[i];
        if (target && lbTrack) lbTrack.scrollTo({ left: target.offsetLeft - lbTrack.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
        lbSync();
      };
      var lbClose = function () {
        if (lightbox.open) lightbox.close();
      };
      lightbox.addEventListener('close', function () {
        document.body.style.overflow = '';
        lbItems.forEach(function (it) { it.classList.remove('is-zoomed'); });
      });
      // Klik op een foto in de galerij opent de lightbox op diezelfde foto
      gallery.addEventListener('click', function (e) {
        var slide = e.target.closest('.product__media-item[data-zoom-index]');
        if (!slide || !gallery.classList.contains('has-zoom')) return;
        lbLoad();
        document.body.style.overflow = 'hidden';
        lightbox.showModal();
        lbGoTo(parseInt(slide.getAttribute('data-zoom-index'), 10), true);
      });
      var lbCloseBtn = lightbox.querySelector('[data-lightbox-close]');
      if (lbCloseBtn) lbCloseBtn.addEventListener('click', lbClose);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) lbClose(); // klik op de achtergrond sluit
      });
      var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-lightbox-next]');
      if (lbPrev) lbPrev.addEventListener('click', function () { lbGoTo(lbIndex() - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { lbGoTo(lbIndex() + 1); });
      if (lbTrack) lbTrack.addEventListener('scroll', function () { window.requestAnimationFrame(lbSync); }, { passive: true });
      lightbox.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') lbGoTo(lbIndex() - 1);
        if (e.key === 'ArrowRight') lbGoTo(lbIndex() + 1);
      });
      // Dubbel-klik / dubbel-tik = inzoomen op 2x (nogmaals = terug)
      var lastTap = 0;
      lightbox.addEventListener('click', function (e) {
        var item = e.target.closest('[data-lightbox-item]');
        if (!item) return;
        var now = Date.now();
        if (now - lastTap < 350) item.classList.toggle('is-zoomed');
        lastTap = now;
      });
    }
  }

  // Variant picker: update hidden id + selected label + prijs + voorraad + ATC state
  var form = document.getElementById('product-form');
  var productRoot = document.querySelector('product-info');
  if (form && productRoot) {
    var root = productRoot;
    var variants = [];
    try {
      var vEl = root.querySelector('script[data-variants]');
      if (vEl) variants = JSON.parse(vEl.textContent);
    } catch (e) {}
    var hiddenId = form.querySelector('[data-variant-id]');
    var atc = form.querySelector('.button--atc');
    var priceEl = root.querySelector('.product__block--price .f-price-item--regular');
    // Radio's staan buiten het <form> (blok-volgorde is vrij) en horen erbij via form="product-form"
    var fieldsets = root.querySelectorAll('fieldset.product-form__input');
    var atcLabel = (atc && atc.getAttribute('data-atc-label')) || 'Ajouter au panier';

    function selectedOptions() {
      var vals = [];
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) vals.push(checked.value);
      });
      return vals;
    }
    var galleryEl = document.querySelector('.product__media-gallery');
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var stickySelect = stickyBar && stickyBar.querySelector('[data-sticky-variant]');
    var stickyAdd = stickyBar && stickyBar.querySelector('[data-sticky-add]');
    var stickyLabel = (stickyAdd && stickyAdd.getAttribute('data-atc-label')) || atcLabel;

    // Dynamic variants: per optie-waarde bepalen of de combinatie bestaat/leverbaar is.
    // Niet-bestaand -> verbergen, uitverkocht -> doorstrepen.
    var dynamicPicker = root.querySelector('[data-dynamic-variants]');
    function refreshVariantStates() {
      if (!dynamicPicker || !variants.length) return;
      var sel = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('input[type="radio"]').forEach(function (radio) {
          var exists = false, available = false;
          variants.forEach(function (v) {
            if (v.options[i] !== radio.value) return;
            var match = true;
            for (var k = 0; k < sel.length; k++) {
              if (k !== i && v.options[k] !== sel[k]) { match = false; break; }
            }
            if (match) {
              exists = true;
              if (v.available) available = true;
            }
          });
          var label = fs.querySelector('label[for="' + radio.id + '"]');
          if (!label) return;
          label.classList.toggle('is-hidden', !exists);
          label.classList.toggle('is-soldout', exists && !available);
        });
      });
    }

    function update() {
      var sel = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      });
      refreshVariantStates();
      if (!match) {
        // Combinatie bestaat niet: koopknoppen blokkeren tot een geldige keuze
        if (fieldsets.length && atc) {
          atc.disabled = true;
          (atc.querySelector('span') || atc).textContent = 'Épuisé';
          if (stickyAdd) { stickyAdd.disabled = true; (stickyAdd.querySelector('span') || stickyAdd).textContent = 'Épuisé'; }
        }
        // Badge meebewegen met de knop-status (anders blijft de vorige stand staan)
        var soldBadge0 = root.querySelector('[data-soldout-badge]');
        if (soldBadge0) soldBadge0.hidden = false;
        return;
      }
      if (hiddenId) hiddenId.value = match.id;
      if (priceEl && match.price) priceEl.textContent = match.price;
      // Besparing: bedrag of percentage, afhankelijk van de prijs-blokinstelling
      var savStyleEl = root.querySelector('[data-savings-style]');
      var savStyle = savStyleEl ? savStyleEl.getAttribute('data-savings-style') : 'amount';
      var savWrap = root.querySelector('[data-savings]');
      if (savWrap) {
        var has = savStyle === 'percent' ? match.pct != null : match.savings != null;
        savWrap.hidden = !has;
        var savEl = savWrap.querySelector('[data-savings-amount]');
        if (has && savEl) savEl.textContent = savStyle === 'percent' ? match.pct + ' %' : match.savings;
      }
      // Doorgestreepte vergelijkprijs: verbergen als de gekozen variant geen korting heeft
      var cmpWrap = root.querySelector('.f-price-item--compare');
      if (cmpWrap) cmpWrap.hidden = match.compare == null;
      var cmpEl = root.querySelector('.f-price-item--compare s'); if (cmpEl && match.compare != null) cmpEl.textContent = match.compare;
      // Spaar-badge (Ahorra X%) uit price.liquid meebewegen met de variant (voorheen bleef die stale)
      var badgeEl = root.querySelector('[data-price-badge]');
      if (badgeEl) { badgeEl.style.display = match.pct == null ? 'none' : ''; if (match.pct != null) badgeEl.textContent = 'Ahorra ' + match.pct + '%'; }
      // Voorraad-indicator: echt aantal bij beheerde voorraad, vaste tekst anders
      var invEl = root.querySelector('[data-inventory]');
      if (invEl) {
        var thr = parseInt(invEl.getAttribute('data-threshold'), 10) || 0;
        var lowT = invEl.getAttribute('data-low-text') || '';
        var fbT = invEl.getAttribute('data-fallback-text') || '';
        var invShow = false, invTxt = '';
        if (match.mgmt) {
          if (match.qty > 0 && match.qty <= thr) { invTxt = lowT.replace('[count]', match.qty); invShow = true; }
        } else if (fbT) { invTxt = fbT; invShow = true; }
        invEl.hidden = !invShow;
        var invTextEl = invEl.querySelector('[data-inventory-text]');
        if (invTextEl) invTextEl.textContent = invTxt;
      }
      if (atc) {
        atc.disabled = !match.available;
        var span = atc.querySelector('span') || atc;
        span.textContent = match.available ? atcLabel : 'Épuisé';
      }
      // Agotado-badge bij de prijs (azel-state, backlog item 7)
      var soldBadge = root.querySelector('[data-soldout-badge]');
      if (soldBadge) soldBadge.hidden = match.available;
      // Hoofdfoto wisselen naar de gekozen variant (kleur staat bij de foto)
      if (match.media != null && galleryEl) {
        var targetItem = galleryEl.querySelector('.product__media-item[data-media-id="' + match.media + '"]');
        if (targetItem) {
          galleryEl.scrollTo({ left: targetItem.offsetLeft - galleryEl.offsetLeft, behavior: 'smooth' });
          document.querySelectorAll('.product__thumbnail').forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(match.media));
          });
        }
      }
      // Sticky-balk synchroniseren met de gekozen variant
      if (stickySelect) stickySelect.value = match.id;
      if (stickyAdd) {
        stickyAdd.disabled = !match.available;
        var sspan = stickyAdd.querySelector('span') || stickyAdd;
        sspan.textContent = match.available ? stickyLabel : 'Épuisé';
      }
    }

    root.querySelectorAll('fieldset.product-form__input input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () {
        var fieldset = r.closest('fieldset');
        if (fieldset) {
          fieldset.querySelectorAll('.variant-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
          var lbl = r.closest('.variant-swatch') || fieldset.querySelector('label[for="' + r.id + '"]');
          if (lbl) lbl.classList.add('is-selected');
          var legendSel = fieldset.querySelector('[data-selected-swatch-value]');
          if (legendSel) legendSel.textContent = r.value;
        }
        update();
      });
    });

    // AJAX add-to-cart → opent de winkelwagen-lade
    if (atc) {
      form.addEventListener('submit', function (e) {
        if (form.hasAttribute('data-bundle-mode')) return; // bundel-widget regelt de submit zelf
        e.preventDefault();
        if (atc.disabled || atc.classList.contains('is-loading')) return;
        var span = atc.querySelector('span') || atc;
        var label = span.textContent;
        atc.classList.add('is-loading');
        atc.setAttribute('aria-busy', 'true');
        span.textContent = 'Añadiendo…';
        var id = (hiddenId && hiddenId.value) || (form.querySelector('[name="id"]') || {}).value;
        window.RVCart.add(id, 1)
          .then(function () {
            atc.classList.remove('is-loading');
            atc.removeAttribute('aria-busy');
            span.textContent = label;
            window.RVCart.open();
          })
          .catch(function () {
            atc.classList.remove('is-loading');
            atc.removeAttribute('aria-busy');
            span.textContent = 'Réessayer';
            setTimeout(function () { span.textContent = label; }, 2000);
          });
      });
    }

    // Sticky add-to-cart: variant-sync, klik, en zichtbaar maken bij scrollen
    if (stickyBar) {
      if (stickySelect) {
        stickySelect.addEventListener('change', function () {
          var v = variants.find(function (x) { return String(x.id) === String(stickySelect.value); });
          if (!v) return;
          // Zet de bijbehorende radio's terug in de hoofd-picker, zodat alles meebeweegt
          fieldsets.forEach(function (fs, i) {
            var radios = fs.querySelectorAll('input[type="radio"]');
            radios.forEach(function (radio) {
              if (radio.value === v.options[i]) {
                radio.checked = true;
                var fieldset = radio.closest('fieldset');
                if (fieldset) {
                  fieldset.querySelectorAll('.variant-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
                  var lbl = radio.closest('.variant-swatch') || fieldset.querySelector('label[for="' + radio.id + '"]');
                  if (lbl) lbl.classList.add('is-selected');
                  var legendSel = fieldset.querySelector('[data-selected-swatch-value]');
                  if (legendSel) legendSel.textContent = radio.value;
                }
              }
            });
          });
          update();
        });
      }
      if (stickyAdd) {
        stickyAdd.addEventListener('click', function () {
          if (stickyAdd.disabled) return;
          if (form.hasAttribute('data-bundle-mode')) {
            // Bundel-modus: de sticky-balk toont één variant, dus voeg bewust 1 stuk toe (de staffel geldt alleen via de bundel-widget zelf)
            var sid = hiddenId && hiddenId.value;
            if (sid) { window.RVCart.add(parseInt(sid, 10), 1).then(function () { window.RVCart.open(); }).catch(function () {}); }
            return;
          }
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }
      var buyBlock = root.querySelector('.product__block--buy_buttons') || atc;
      if (buyBlock && 'IntersectionObserver' in window) {
        stickyBar.hidden = false;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            // Toon de balk zodra de hoofd-ATC uit beeld is
            stickyBar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
          });
        }, { threshold: 0 });
        io.observe(buyBlock);
      }
    }

    // Beginstand: dynamic-variant markeringen direct toepassen
    refreshVariantStates();
  }

  // Recently viewed: producthandle bijhouden in localStorage (max 12, nieuwste eerst)
  var recentRoot = document.querySelector('product-info[data-product-handle]');
  if (recentRoot) {
    try {
      var rvKey = 'aj-recent-products';
      var rvHandle = recentRoot.getAttribute('data-product-handle');
      var rvList = JSON.parse(localStorage.getItem(rvKey) || '[]');
      rvList = rvList.filter(function (h) { return h !== rvHandle; });
      rvList.unshift(rvHandle);
      localStorage.setItem(rvKey, JSON.stringify(rvList.slice(0, 12)));
    } catch (e) {}
  }

  // Slideshow met tekst — dots volgen scroll + klik + optioneel autoplay
  document.querySelectorAll('[data-slides]').forEach(function (slideshow) {
    var track = slideshow.querySelector('[data-slides-track]');
    var dots = slideshow.querySelectorAll('[data-slides-dot]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-slide]');
    if (slides.length < 2) return;
    var current = 0;
    function goTo(i) {
      current = (i + slides.length) % slides.length;
      var target = slides[current];
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-slides-dot'), 10)); restart(); });
    });
    var syncDots = function () {
      var idx = Math.round(track.scrollLeft / track.clientWidth);
      current = Math.max(0, Math.min(slides.length - 1, idx));
      dots.forEach(function (x, j) { x.classList.toggle('is-active', j === current); });
    };
    track.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); }, { passive: true });
    var secs = parseInt(slideshow.getAttribute('data-autoplay'), 10) || 0;
    var timer;
    function restart() { if (secs > 0) { clearInterval(timer); timer = setInterval(function () { goTo(current + 1); }, secs * 1000); } }
    restart();
  });

  // ===== Navigatie V2 =====

  // Werkelijke hoogte van announcement+header -> CSS-var voor de sticky mediakolom (productpagina)
  var stickyTop = document.querySelector('.sticky-top');
  if (stickyTop) {
    var setStickyVar = function () {
      document.documentElement.style.setProperty('--product-sticky-top', (stickyTop.offsetHeight + 16) + 'px');
    };
    setStickyVar();
    window.addEventListener('load', setStickyVar);
    window.addEventListener('resize', function () { window.requestAnimationFrame(setStickyVar); });
  }

  // Desktopmenu: hover-intent of klik-modus, toetsenbord (focus opent, Escape sluit)
  var navRoot = document.querySelector('[data-nav]');
  if (navRoot) {
    var navItems = navRoot.querySelectorAll('[data-nav-item]');
    var wantHover = navRoot.getAttribute('data-nav-trigger') !== 'click';
    var useHover = wantHover && window.matchMedia('(hover: hover)').matches;
    var navCloseTimer = null;

    var navClose = function (item) {
      item.classList.remove('is-open');
      var t = item.querySelector('.site-header__nav-link');
      if (t) t.setAttribute('aria-expanded', 'false');
    };
    var navCloseAll = function (except) {
      navItems.forEach(function (item) { if (item !== except) navClose(item); });
    };
    var navOpen = function (item) {
      navCloseAll(item);
      item.classList.add('is-open');
      var t = item.querySelector('.site-header__nav-link');
      if (t) t.setAttribute('aria-expanded', 'true');
    };

    navItems.forEach(function (item) {
      var trigger = item.querySelector('.site-header__nav-link');
      if (useHover) {
        item.addEventListener('mouseenter', function () { clearTimeout(navCloseTimer); navOpen(item); });
        item.addEventListener('mouseleave', function () {
          clearTimeout(navCloseTimer);
          navCloseTimer = setTimeout(function () { navClose(item); }, 150);
        });
      }
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          if (useHover) return; // hover-modus: klik = gewoon navigeren
          if (!item.classList.contains('is-open')) { e.preventDefault(); navOpen(item); } // 2e klik navigeert
        });
      }
      item.addEventListener('focusin', function (e) {
        // Alleen openen bij toetsenbord-focus; muisklik-focus zou in klik-modus
        // het paneel vóór de klik openen (eerste klik navigeert dan meteen).
        try { if (e.target.matches(':focus-visible')) navOpen(item); } catch (err) { navOpen(item); }
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) navClose(item);
      });
    });
    document.addEventListener('click', function (e) { if (!navRoot.contains(e.target)) navCloseAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') navCloseAll(); });
  }

  // Zoekbalk + predictive search (native Shopify API, debounce 250ms)
  var searchBar = document.querySelector('[data-header-search]');
  var searchToggle = document.querySelector('[data-search-toggle]');
  if (searchBar && searchToggle) {
    var searchInput = searchBar.querySelector('[data-search-input]');
    var searchResults = searchBar.querySelector('[data-predictive-results]');
    var searchDebounce = null;
    var searchAbort = null;

    var openSearch = function () {
      searchBar.hidden = false;
      searchToggle.setAttribute('aria-expanded', 'true');
      if (searchInput) searchInput.focus();
    };
    var closeSearch = function () {
      var wasOpen = !searchBar.hidden;
      searchBar.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
      if (searchResults) { searchResults.hidden = true; searchResults.innerHTML = ''; }
      if (wasOpen) searchToggle.focus(); // focus terug naar de trigger
    };
    searchToggle.addEventListener('click', function (e) {
      e.preventDefault(); // zonder JS blijft dit een link naar /search
      if (searchBar.hidden) openSearch(); else closeSearch();
    });
    var searchCloseBtn = searchBar.querySelector('[data-search-close]');
    if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || searchBar.hidden) return;
      // Laag-volgorde: een open dialog (lightbox/quick-shop) of drawer ligt bóven
      // de zoekbalk — dan sluit Escape eerst die laag, niet de zoekbalk.
      if (document.querySelector('dialog[open]')) return;
      if (document.querySelector('[data-cart-drawer].is-open')) return;
      if (document.querySelector('[data-menu-drawer].is-open')) return;
      if (document.querySelector('[data-filter-drawer].is-open')) return;
      closeSearch();
    });
    document.addEventListener('click', function (e) {
      if (searchBar.hidden) return;
      if (!searchBar.contains(e.target) && !searchToggle.contains(e.target)) closeSearch();
    });

    if (searchInput && searchResults) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchDebounce);
        var q = searchInput.value.trim();
        if (q.length < 2) { searchResults.hidden = true; searchResults.innerHTML = ''; return; }
        searchDebounce = setTimeout(function () {
          if (searchAbort) searchAbort.abort();
          searchAbort = ('AbortController' in window) ? new AbortController() : null;
          var url = searchBar.getAttribute('data-predictive-url') +
            '?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection&resources[limit]=4&resources[options][unavailable_products]=last' +
            '&section_id=predictive-search';
          fetch(url, searchAbort ? { signal: searchAbort.signal } : undefined)
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) {
              if (!html) return;
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('.shopify-section');
              if (fresh) { searchResults.innerHTML = fresh.innerHTML; searchResults.hidden = false; }
            })
            .catch(function () {});
        }, 250);
      });
    }
  }

  // Mobiel menu: accordions met aparte link + uitklapknop (2 niveaus diep)
  document.querySelectorAll('[data-drawer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.closest('.menu-drawer__row');
      var sub = row && row.nextElementSibling;
      if (!sub) return;
      var openNow = sub.hidden;
      sub.hidden = !openNow;
      btn.setAttribute('aria-expanded', openNow ? 'true' : 'false');
      btn.classList.toggle('is-open', openNow);
    });
  });

  // Announcement-rotatie (alleen bij >1 boodschap) + toegankelijke pauzeknop
  (function () {
    var bar = document.querySelector('[data-announcement]');
    if (!bar) return;
    var slides = bar.querySelectorAll('[data-announce-slide]');
    if (slides.length < 2) return;
    var idx = 0;
    var paused = false;
    var secs = parseInt(bar.getAttribute('data-rotate'), 10) || 5;
    setInterval(function () {
      if (paused) return;
      idx = (idx + 1) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
    }, secs * 1000);
    var pauseBtn = bar.querySelector('[data-announce-pause]');
    if (pauseBtn) {
      var icoPause = pauseBtn.querySelector('.announcement-bar__pause-icon--pause');
      var icoPlay = pauseBtn.querySelector('.announcement-bar__pause-icon--play');
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        if (icoPause) icoPause.hidden = paused;
        if (icoPlay) icoPlay.hidden = !paused;
      });
    }
  })();

  // Transparante header (homepage): solid zodra er gescrold is
  var overlayHeader = document.querySelector('[data-overlay-header]');
  if (overlayHeader) {
    // Fallback-klasse voor browsers zonder :has() (mobiele hero-compensatie)
    document.body.classList.add('has-overlay-header');
    var syncOverlay = function () { overlayHeader.classList.toggle('is-scrolled', window.scrollY > 24); };
    syncOverlay();
    window.addEventListener('scroll', function () { window.requestAnimationFrame(syncOverlay); }, { passive: true });
  }

  // Scroll-reveal + page-fade (azel Impact-gedrag; item 12) — uit bij reduced-motion
  // NB: .usp-bar__slide hoort hier NIET in — de mobiele carousel stuurt zelf opacity
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    var revealEls = document.querySelectorAll('.product-card, .section-heading, .promo-tile, .testimonial');
    if (revealEls.length) {
      var revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-revealed'); revealIO.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function (el, i) {
        el.classList.add('reveal-item');
        el.style.setProperty('--reveal-delay', ((i % 4) * 0.08) + 's');
        revealIO.observe(el);
      });
    }
    // Korte fade-out bij echte interne navigatie. De check gebeurt uitgesteld
    // (setTimeout 0) zodat óók AJAX-handlers die later op document registreren
    // (paginering, filters) hun preventDefault al gedaan hebben — anders zou de
    // pagina op opacity 0 blijven hangen zonder navigatie.
    document.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      var a = e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('/checkout') === 0) return;
      if (a.origin && a.origin !== window.location.origin) return;
      setTimeout(function () {
        if (!e.defaultPrevented) document.body.classList.add('is-leaving');
      }, 0);
    });
    window.addEventListener('pageshow', function () { document.body.classList.remove('is-leaving'); });
  }

  // ===== Collectie & homepage V3 =====

  // Prijs-slider: dubbele range gekoppeld aan de van/tot-velden; submit via 'change'
  function initPriceFilters() {
    document.querySelectorAll('[data-price-filter]').forEach(function (pf) {
      if (pf.hasAttribute('data-price-init')) return;
      pf.setAttribute('data-price-init', '');
      var rMin = pf.querySelector('[data-price-range="min"]');
      var rMax = pf.querySelector('[data-price-range="max"]');
      var nMin = pf.querySelector('[data-price-input="min"]');
      var nMax = pf.querySelector('[data-price-input="max"]');
      var fill = pf.querySelector('[data-price-fill]');
      var top = parseInt(pf.getAttribute('data-max'), 10) || 100;
      function paint() {
        var lo = parseInt(rMin.value, 10), hi = parseInt(rMax.value, 10);
        if (fill) {
          fill.style.left = (lo / top * 100) + '%';
          fill.style.width = ((hi - lo) / top * 100) + '%';
        }
      }
      function syncFromRange(fireChange) {
        var lo = Math.min(parseInt(rMin.value, 10), parseInt(rMax.value, 10));
        var hi = Math.max(parseInt(rMin.value, 10), parseInt(rMax.value, 10));
        rMin.value = lo; rMax.value = hi;
        // Grenswaarden = geen filter (veld leeg laten, dan verdwijnt de URL-param)
        if (nMin) nMin.value = lo > 0 ? lo : '';
        if (nMax) nMax.value = hi < top ? hi : '';
        paint();
        if (fireChange && nMin) nMin.dispatchEvent(new Event('change', { bubbles: true }));
      }
      [rMin, rMax].forEach(function (r) {
        r.addEventListener('input', function () { syncFromRange(false); });
        r.addEventListener('change', function () { syncFromRange(true); });
      });
      [nMin, nMax].forEach(function (n) {
        if (!n) return;
        n.addEventListener('change', function () {
          if (nMin && nMin.value !== '') { var pMin = parseInt(nMin.value, 10); rMin.value = Math.max(0, Math.min(top, isNaN(pMin) ? 0 : pMin)); }
          if (nMax && nMax.value !== '') { var pMax = parseInt(nMax.value, 10); rMax.value = Math.max(0, Math.min(top, isNaN(pMax) ? top : pMax)); }
          paint();
        });
      });
      paint();
    });
  }
  initPriceFilters();

  // Filter-drawer openen/sluiten
  var filterDrawer = document.querySelector('[data-filter-drawer]');
  var filterOverlay = document.querySelector('[data-filter-overlay]');
  function openFilterDrawer() {
    if (!filterDrawer) return;
    filterDrawer.classList.add('is-open');
    filterDrawer.setAttribute('aria-hidden', 'false');
    if (filterOverlay) filterOverlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeFilterDrawer() {
    if (!filterDrawer) return;
    var wasOpen = filterDrawer.classList.contains('is-open');
    filterDrawer.classList.remove('is-open');
    filterDrawer.setAttribute('aria-hidden', 'true');
    if (filterOverlay) filterOverlay.hidden = true;
    document.body.style.overflow = '';
    if (wasOpen) {
      var opener = document.querySelector('[data-filter-open]');
      if (opener) opener.focus(); // focus terug naar de trigger
    }
  }
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilterDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !filterDrawer || !filterDrawer.classList.contains('is-open')) return;
    if (document.querySelector('dialog[open]')) return; // dialog erboven sluit eerst
    closeFilterDrawer();
  });

  // Collectie: AJAX-laag — filters/sorteren/paginering zonder volledige herlaad
  var collRoot = document.querySelector('[data-collection-root]');
  if (collRoot) {
    // Nieuwste actie wint: lopende fetch wordt afgebroken (geen verouderde swap)
    var collAbort = null;
    var applyCollection = function (url, push) {
      var content = document.querySelector('[data-collection-content]');
      if (!content) { window.location.href = url; return; }
      if (collAbort) collAbort.abort();
      collAbort = ('AbortController' in window) ? new AbortController() : null;
      content.classList.add('is-loading');
      fetch(url, collAbort ? { signal: collAbort.signal } : undefined)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('http')); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-collection-content]');
          if (!fresh) { window.location.href = url; return; }
          content.innerHTML = fresh.innerHTML;
          // Drawer-inhoud staat buiten het swap-gebied — apart verversen
          var freshDrawer = doc.querySelector('[data-filter-drawer-content]');
          var liveDrawer = document.querySelector('[data-filter-drawer-content]');
          if (freshDrawer && liveDrawer) liveDrawer.innerHTML = freshDrawer.innerHTML;
          // Zoekpagina: de teller-H1 staat buiten het swap-gebied — meenemen
          var freshTitle = doc.querySelector('.search__title');
          var liveTitle = document.querySelector('.search__title');
          if (freshTitle && liveTitle) liveTitle.innerHTML = freshTitle.innerHTML;
          content.classList.remove('is-loading');
          if (push !== false) history.pushState({ ajColl: true }, '', url);
          closeFilterDrawer();
          initPriceFilters();
          var top = content.getBoundingClientRect().top + window.scrollY - 130;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return; // vervangen door nieuwere actie
          window.location.href = url;
        });
    };

    var buildFilterUrl = function (form) {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (String(value).trim() !== '') params.append(key, value);
      });
      return (collRoot.getAttribute('data-collection-url') || window.location.pathname) + '?' + params.toString();
    };

    // Elke filterwijziging direct toepassen (checkbox of prijsveld)
    document.addEventListener('change', function (e) {
      var form = e.target.closest('[data-filter-form]');
      if (!form) return;
      applyCollection(buildFilterUrl(form));
    });
    // Sorteren: huidige URL-parameters behouden, alleen sort_by wisselen
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-sort-select]');
      if (!sel) return;
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sel.value);
      applyCollection(window.location.pathname + '?' + params.toString());
    });
    // Paginering + "quitar filtros" via dezelfde AJAX-flow
    document.addEventListener('click', function (e) {
      var pag = e.target.closest('[data-pagination] a');
      var clear = e.target.closest('[data-filters-clear]');
      var open = e.target.closest('[data-filter-open]');
      var close = e.target.closest('[data-filter-close]');
      if (pag) { e.preventDefault(); applyCollection(pag.getAttribute('href')); }
      else if (clear) { e.preventDefault(); applyCollection(clear.getAttribute('href')); }
      else if (open) { openFilterDrawer(); }
      else if (close) { closeFilterDrawer(); }
    });
    window.addEventListener('popstate', function () {
      applyCollection(window.location.href, false);
    });
  }

  // Quick-shop: kaartknop -> dialog met compacte productweergave (?view=quick)
  var qsDialog = document.querySelector('[data-quick-shop]');
  if (qsDialog && typeof qsDialog.showModal === 'function') {
    var qsHolder = qsDialog.querySelector('[data-quick-shop-holder]');
    var qsClose = function () { if (qsDialog.open) qsDialog.close(); };
    qsDialog.addEventListener('close', function () { document.body.style.overflow = ''; });
    qsDialog.addEventListener('click', function (e) { if (e.target === qsDialog) qsClose(); });

    document.addEventListener('click', function (e) {
      var trg = e.target.closest('[data-quick-shop-trigger]');
      if (trg) {
        e.preventDefault();
        var url = trg.getAttribute('data-product-url');
        url += (url.indexOf('?') > -1 ? '&' : '?') + 'view=quick';
        fetch(url)
          .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
          .then(function (html) {
            qsHolder.innerHTML = html;
            document.body.style.overflow = 'hidden';
            qsDialog.showModal();
          })
          .catch(function () { window.location.href = trg.getAttribute('data-product-url'); });
        return;
      }
      if (e.target.closest('[data-quick-shop-close]')) qsClose();
    });

    // Variantkeuze in de dialog: prijs/foto/knop live bijwerken
    var qsFind = function () {
      var dataEl = qsDialog.querySelector('[data-qs-variants]');
      if (!dataEl) return null;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return null; }
      var radios = qsDialog.querySelectorAll('[data-qs-radio]:checked');
      var sel = [];
      radios.forEach(function (r) { sel[parseInt(r.getAttribute('data-option-index'), 10)] = r.value; });
      if (!sel.length) return variants[0] || null;
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return sel[i] === undefined || o === sel[i]; });
      }) || null;
    };
    qsDialog.addEventListener('change', function (e) {
      var radio = e.target.closest('[data-qs-radio]');
      if (!radio) return;
      var fs = radio.closest('fieldset');
      if (fs) {
        fs.querySelectorAll('.variant-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
        var lbl = fs.querySelector('label[for="' + radio.id + '"]');
        if (lbl) lbl.classList.add('is-selected');
        var legendSel = fs.querySelector('[data-qs-selected]');
        if (legendSel) legendSel.textContent = radio.value;
      }
      var match = qsFind();
      var addBtn = qsDialog.querySelector('[data-qs-add]');
      if (!match) {
        // Onbestaande optiecombinatie: koopknop blokkeren + variant-id wissen zodat niet stilzwijgend de vorige variant wordt toegevoegd
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.removeAttribute('data-variant-id');
          (addBtn.querySelector('span') || addBtn).textContent = 'Épuisé';
        }
        return;
      }
      var priceEl = qsDialog.querySelector('[data-qs-price]');
      var cmpEl = qsDialog.querySelector('[data-qs-compare]');
      var imgEl = qsDialog.querySelector('[data-qs-image]');
      if (priceEl) priceEl.textContent = match.price;
      if (cmpEl) { cmpEl.hidden = match.compare == null; if (match.compare != null) cmpEl.textContent = match.compare; }
      if (imgEl && match.img) imgEl.src = match.img;
      if (addBtn) {
        addBtn.setAttribute('data-variant-id', match.id);
        addBtn.disabled = !match.available;
        (addBtn.querySelector('span') || addBtn).textContent = match.available ? 'Ajouter au panier' : 'Épuisé';
      }
    });
    // Toevoegen: 1 stuk via RVCart -> dialog dicht, drawer open
    qsDialog.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-qs-add]');
      if (!addBtn || addBtn.disabled || addBtn.classList.contains('is-loading')) return;
      var span = addBtn.querySelector('span') || addBtn;
      var label = span.textContent;
      addBtn.classList.add('is-loading');
      span.textContent = 'Añadiendo…';
      window.RVCart.add(parseInt(addBtn.getAttribute('data-variant-id'), 10), 1)
        .then(function () {
          addBtn.classList.remove('is-loading');
          span.textContent = label;
          qsClose();
          window.RVCart.open();
        })
        .catch(function () {
          addBtn.classList.remove('is-loading');
          span.textContent = 'Réessayer';
          setTimeout(function () { span.textContent = label; }, 2000);
        });
    });
  }

  // Collectie-tabs (homepage): tabblad wisselt paneel
  document.querySelectorAll('[data-collection-tabs]').forEach(function (tabs) {
    tabs.addEventListener('click', function (e) {
      var btn = e.target.closest('.collection-tabs__tab');
      if (!btn) return;
      var idx = btn.getAttribute('data-tab-index');
      tabs.querySelectorAll('.collection-tabs__tab').forEach(function (b) {
        var actief = b === btn;
        b.classList.toggle('is-active', actief);
        b.setAttribute('aria-selected', actief ? 'true' : 'false');
      });
      tabs.querySelectorAll('[data-tab-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-tab-panel') !== idx;
      });
    });
  });

  // Shop the look: punt opent mini-kaart; buiten klikken sluit
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-hotspot]');
    document.querySelectorAll('.hotspot.is-open').forEach(function (h) {
      if (!dot || h !== dot.closest('.hotspot')) {
        h.classList.remove('is-open');
        var b = h.querySelector('[data-hotspot]');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
    if (dot) {
      var spot = dot.closest('.hotspot');
      var open = spot.classList.toggle('is-open');
      dot.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  // ===== V4: footer/accounts/popups/sectietypes =====

  // Countdown-banner: aftellen naar een vaste einddatum
  document.querySelectorAll('[data-countdown-target]').forEach(function (bar) {
    var end = new Date(String(bar.getAttribute('data-end')).replace(' ', 'T'));
    if (isNaN(end.getTime())) return;
    var dEl = bar.querySelector('[data-cd-days]');
    var hEl = bar.querySelector('[data-cd-hours]');
    var mEl = bar.querySelector('[data-cd-mins]');
    var sEl = bar.querySelector('[data-cd-secs]');
    var units = bar.querySelector('[data-countdown-units]');
    var expiredText = bar.querySelector('[data-countdown-expired-text]');
    var timer = setInterval(tick, 1000);
    function tick() {
      var diff = Math.floor((end - new Date()) / 1000);
      if (diff <= 0) {
        clearInterval(timer);
        if (bar.getAttribute('data-expired') === 'text') {
          if (units) units.hidden = true;
          if (expiredText) expiredText.hidden = false;
        } else {
          bar.hidden = true;
        }
        return;
      }
      if (dEl) dEl.textContent = Math.floor(diff / 86400);
      if (hEl) hEl.textContent = Math.floor(diff % 86400 / 3600);
      if (mEl) mEl.textContent = Math.floor(diff % 3600 / 60);
      if (sEl) sEl.textContent = diff % 60;
    }
    tick();
  });

  // Voor/na-vergelijker: range stuurt de clip-breedte
  document.querySelectorAll('[data-image-compare]').forEach(function (wrap) {
    var range = wrap.querySelector('[data-compare-range]');
    var clip = wrap.querySelector('[data-compare-clip]');
    var divider = wrap.querySelector('[data-compare-divider]');
    if (!range || !clip) return;
    var paint = function () {
      clip.style.width = range.value + '%';
      if (divider) divider.style.left = range.value + '%';
    };
    range.addEventListener('input', paint);
    paint();
  });

  // Uitgelicht product: variantwissel + ATC via RVCart (zelfde datapatroon als quick-shop)
  document.querySelectorAll('[data-featured-product]').forEach(function (fp) {
    var dataEl = fp.querySelector('[data-fp-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var addBtn = fp.querySelector('[data-fp-add]');
    function fpMatch() {
      var sel = [];
      fp.querySelectorAll('[data-fp-radio]:checked').forEach(function (r) { sel[parseInt(r.getAttribute('data-option-index'), 10)] = r.value; });
      if (!sel.length) return variants[0] || null;
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return sel[i] === undefined || o === sel[i]; });
      }) || null;
    }
    fp.addEventListener('change', function (e) {
      var radio = e.target.closest('[data-fp-radio]');
      if (!radio) return;
      var fs = radio.closest('fieldset');
      if (fs) {
        fs.querySelectorAll('.variant-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
        var lbl = fs.querySelector('label[for="' + radio.id + '"]');
        if (lbl) lbl.classList.add('is-selected');
        var legendSel = fs.querySelector('[data-fp-selected]');
        if (legendSel) legendSel.textContent = radio.value;
      }
      var match = fpMatch();
      if (!match) {
        // Onbestaande optiecombinatie: koopknop blokkeren + variant-id wissen zodat niet stilzwijgend de vorige variant wordt toegevoegd
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.removeAttribute('data-variant-id');
          (addBtn.querySelector('span') || addBtn).textContent = 'Épuisé';
        }
        return;
      }
      var priceEl = fp.querySelector('[data-fp-price]');
      var cmpEl = fp.querySelector('[data-fp-compare]');
      var imgEl = fp.querySelector('[data-fp-image]');
      if (priceEl) priceEl.textContent = match.price;
      if (cmpEl) { cmpEl.hidden = match.compare == null; if (match.compare != null) cmpEl.textContent = match.compare; }
      if (imgEl && match.img) imgEl.src = match.img;
      if (addBtn) {
        addBtn.setAttribute('data-variant-id', match.id);
        addBtn.disabled = !match.available;
        (addBtn.querySelector('span') || addBtn).textContent = match.available ? 'AJOUTER AU PANIER' : 'Épuisé';
      }
    });
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;
        var span = addBtn.querySelector('span') || addBtn;
        var label = span.textContent;
        addBtn.classList.add('is-loading');
        span.textContent = 'Añadiendo…';
        window.RVCart.add(parseInt(addBtn.getAttribute('data-variant-id'), 10), 1)
          .then(function () { addBtn.classList.remove('is-loading'); span.textContent = label; window.RVCart.open(); })
          .catch(function () { addBtn.classList.remove('is-loading'); span.textContent = 'Réessayer'; setTimeout(function () { span.textContent = label; }, 2000); });
      });
    }
  });

  // Land-select voorselecteren (adresformulieren, geen dynamische provincie-lijst)
  document.querySelectorAll('select[data-country-default]').forEach(function (sel) {
    var wens = sel.getAttribute('data-country-default');
    if (!wens) return;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === wens || sel.options[i].text === wens) { sel.selectedIndex = i; break; }
    }
  });

  // Leeftijdscheck-popup: blokkerend, bevestiging 365 dagen onthouden (default UIT)
  var agePopup = document.querySelector('[data-age-popup]');
  if (agePopup && typeof agePopup.showModal === 'function') {
    var ageKey = 'aj-age-ok';
    var ageOk = false;
    try { ageOk = parseInt(localStorage.getItem(ageKey) || '0', 10) > Date.now(); } catch (e) {}
    if (!ageOk && !(window.Shopify && window.Shopify.designMode)) {
      agePopup.showModal();
      agePopup.addEventListener('cancel', function (e) { e.preventDefault(); }); // Escape omzeilt de check niet
    }
    var approve = agePopup.querySelector('[data-age-approve]');
    var decline = agePopup.querySelector('[data-age-decline]');
    var back = agePopup.querySelector('[data-age-back]');
    var stepQ = agePopup.querySelector('[data-age-step-question]');
    var stepD = agePopup.querySelector('[data-age-step-declined]');
    if (approve) approve.addEventListener('click', function () {
      try { localStorage.setItem(ageKey, String(Date.now() + 31536000000)); } catch (e) {}
      agePopup.close();
    });
    if (decline) decline.addEventListener('click', function () { if (stepQ) stepQ.hidden = true; if (stepD) stepD.hidden = false; });
    if (back) back.addEventListener('click', function () { if (stepD) stepD.hidden = true; if (stepQ) stepQ.hidden = false; });
  }

  // Nieuwsbrief-popup: na X seconden, X dagen stil na sluiten, nooit óver een andere laag (default UIT)
  var nlPopup = document.querySelector('[data-newsletter-popup]');
  if (nlPopup && typeof nlPopup.showModal === 'function') {
    var nlKey = 'aj-nl-popup-tot';
    var nlStil = false;
    try { nlStil = parseInt(localStorage.getItem(nlKey) || '0', 10) > Date.now(); } catch (e) {}
    var nlDagen = parseInt(nlPopup.getAttribute('data-days'), 10) || 30;
    var nlSluit = function () {
      try { localStorage.setItem(nlKey, String(Date.now() + nlDagen * 86400000)); } catch (e) {}
      if (nlPopup.open) nlPopup.close();
    };
    nlPopup.addEventListener('close', nlSluit);
    var nlCloseBtn = nlPopup.querySelector('[data-nl-popup-close]');
    if (nlCloseBtn) nlCloseBtn.addEventListener('click', nlSluit);
    nlPopup.addEventListener('click', function (e) { if (e.target === nlPopup) nlSluit(); });
    if (!nlStil && !(window.Shopify && window.Shopify.designMode)) {
      setTimeout(function () {
        // Niet openen als er al een laag boven de pagina staat
        if (document.querySelector('dialog[open]')) return;
        if (document.querySelector('[data-cart-drawer].is-open, [data-menu-drawer].is-open, [data-filter-drawer].is-open')) return;
        if (searchBar && !searchBar.hidden) return;
        nlPopup.showModal();
      }, (parseInt(nlPopup.getAttribute('data-delay'), 10) || 8) * 1000);
    }
  }
})();
